import { render, staticRenderFns } from "./select_usercenter_user.vue?vue&type=template&id=8a4c5aee&scoped=true&"
import script from "./select_usercenter_user.vue?vue&type=script&lang=js&"
export * from "./select_usercenter_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4c5aee",
  null
  
)

export default component.exports